import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOrganizationData } from '@/contexts/OrganizationContext';

export const OrgTimezoneNotice = () => {
  const { t } = useTranslation();
  const { timezoneState, retryTimezone } = useOrganizationData();

  if (timezoneState.status === 'loading') {
    return (
      <Alert severity='info' sx={{ mb: 3 }}>
        {t('Using your browser timezone while the organization timezone loads.')}
      </Alert>
    );
  }

  if (timezoneState.status === 'error') {
    return (
      <Alert
        severity='warning'
        sx={{ mb: 3 }}
        action={
          <Button color='inherit' onClick={retryTimezone} size='small' aria-label={t('Retry organization timezone')}>
            {t('Retry')}
          </Button>
        }
      >
        {t('We could not load the organization timezone. Dashboard metrics are using your browser timezone.')}
      </Alert>
    );
  }

  return null;
};
